import Vue from 'vue'
import Vuex from 'vuex'

import mutations from '@/store/mutations'
import actions from '@/store/actions'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: true,
        resources: [],
        languages: [],
        resourceTypes: [],
        topics: [],
        language: window.drupalSettings.language
    },
    mutations,
    actions
})
